<template>
  <ubi-page-container class="PostsListImmo" wide-main-content>
    <template v-slot:page-actions>
      <buttons-header-list
          :filter="filter"
          v-on:fetch-models-lots="fetchModelsLots"
          v-on:fetch-models="fetchModels"
          v-on:fetch-models-cmiste="fetchModelsCmiste"
          v-on:gestion-modal-new-lot="gestionModalNewLot"
          v-on:change-users="changeUsers"
      />
    </template>
    <div
        v-loading="loadingStatus"
        :element-loading-text="$t('portals.list.chargementDonnees')"
    >
      <!-- Modales -->
      <dialogs-posts-list-immo
          ref="dialogsComponent"
          :loadingCMIcreatePost="loadingCMIcreatePost"
          :rulesCMI="rulesCMI"
          :selectModeleCmiste="selectModeleCmiste"
          :selectTerrainCmisteModele="selectTerrainCmisteModele"
          :labelModeleTerrain="labelModeleTerrain"
          :listeTerrains="listeTerrains"
          :listeModeles="listeModeles"
          :listeProgramModeles="listeProgramModeles"
          :currentModelId="currentModelId"
          :currentProgramId="currentProgramId"
          :currentLandId="currentLandId"
          :referenceDuplication="referenceDuplication"
          :modalCmisteModelDisabled="modalCmisteModelDisabled"
          :modalDelete="modalDelete"
          :modalConfirmedDeleteList="modalConfirmedDeleteList"
          :titreModalConfirmedDeleteList="titreModalConfirmedDeleteList"
          :selected="selection"
          :modalConfirmedChangeContactList="modalConfirmedChangeContactList"
          :modalCreationLot="modalCreationLot"
          :modalDuplicate="modalDuplicate"
          v-on:archiver-bv="archiverBienVendu()"
          v-on:close-modal-show-models="modalShowModels = false"
          v-on:fusionner="fusionner($event)"
          v-on:dupliquer="dupliquer($event)"
          v-on:delete-post="supprimer(deleteId)"
          v-on:close-modal-delete="closeModalDelete()"
          v-on:sold-post="vendu(deleteId)"
          v-on:delete-selected="supprimer(selection)"
          v-on:delete-all-selected="supprimerAll(selection)"
          v-on:close-change-contacts="closeChangeContacts()"
          v-on:unselect-call="doSelect(null)"
          v-on:dupliquer-annonce="setReferenceDuplication($event)"
          v-on:close-modal-duplicate="closeModalDuplicate()"
          v-on:stop-popup-bv="closePopupBiensVendus()"
      ></dialogs-posts-list-immo>
      <dialog-change-user-multiple-posts
          :visible.sync="showAssignUserModal"
          :selected-ids="assignUserSelection"
          @success="onAssignUserSuccess"
      />
      <!-- Fin modales -->

      <!-- Recherche -->
      <div>
        <!-- Nouveau composant API indépendant -->
        <!--  IMPORTANT : Ne monter ApiSearchForm que quand les données (users, contacts) sont chargées -->
        <api-search-form
            v-if="dataReady"
            ref="apiSearchForm"
            business-domain="immo"
            store-name="postsListImmo"
            :route="currentRoute"
            :user-context="userContext"
            :cached-data="{ users, contacts }"
            :realtime="false"
            :global-loading="loadingStatus"
            @search="handleSearchFromApi"
            @config-loaded="handleConfigLoaded"
            @config-error="handleConfigError"
            @ready="handleSearchFormReady"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!--Affichage Vignette-->
        <CardsListImmo
            v-if="affichageReduit === false"
            :affichageReduit="affichageReduit"
            :limits="limits"
            :total="results.total"
            :page="page"
            :limit="limit"
            :sort="sort"
            :sortProperties="sortProperties"
            :results="results"
            :unselect="unselect"
            :annonceFlux="annonceFlux"
            v-on:load-data="fetchList()"
            v-on:switch-published="onSwitchPublished"
            v-on:do-select="doSelect($event)"
            v-on:change-contacts="changeContacts($event)"
            v-on:change-users="changeUsers($event)"
            v-on:open-delete-modal="openDeleteModal($event)"
            v-on:open-use-model-modal="openUseModelModal($event)"
            v-on:open-duplicate-modal="openDuplicateModal($event)"
            v-on:archiver-bien-vendu-modale="archiverBienVenduModale($event)"
            v-on:modal-delete-list="activationModalConfirmedDeleteList($event)"
            v-on:affichage-reduit="gestionAffichageReduit($event)"
            v-on:exporter="exporter($event)"
            v-on:diffuse-later="$emit('diffuse-later', $event)"
        />
        <!-- Affichage liste -->
        <div v-else>
          <TableListImmo
              v-if="affichageReduit === true"
              :affichageReduit="affichageReduit"
              :limits="limits"
              :total="results.total"
              :page="page"
              :limit="limit"
              :sort="sort"
              :sortProperties="sortProperties"
              :results="results"
              :annonceFlux="annonceFlux"
              :unselect="unselect"
              v-on:load-data="fetchList"
              v-on:switch-published="onSwitchPublished"
              v-on:do-select="doSelect($event)"
              v-on:change-contacts="changeContacts($event)"
              v-on:change-users="changeUsers($event)"
              v-on:open-delete-modal="openDeleteModal($event)"
              v-on:open-use-model-modal="openUseModelModal($event)"
              v-on:open-duplicate-modal="openDuplicateModal($event)"
              v-on:archiver-bien-vendu-modale="archiverBienVenduModale($event)"
              v-on:modal-delete-list="activationModalConfirmedDeleteList($event)"
              v-on:affichage-reduit="gestionAffichageReduit($event)"
              v-on:exporter="exporter($event)"
              v-on:diffuse-later="$emit('diffuse-later', $event)"
          />
        </div>
      </div>
    </div>
    <dialog-draft-portal-selection
        :visible.sync="showDraftPortalDialog"
        :post-count="draftPortalDialogPostCount"
        @keep="onDraftPortalKeep"
        @clear="onDraftPortalClear"
        @cancel="onDraftPortalCancel"
    />
  </ubi-page-container>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import {
  getPosts
} from '@/services/posts'
import { getUsers, putStopPopupBiensVendus } from '@/services/users'
import ButtonsHeaderList from './Header/ButtonsHeaderList'
import CardsListImmo from '../components/PostsList/CardsListImmo'
import DialogsPostsListImmo from './Dialog/DialogsPostsListImmo'
import TableListImmo from '../components/PostsList/TableListImmo'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import DialogChangeUserMultiplePosts from './Dialog/DialogChangeUserMultiplePosts'
import DialogDraftPortalSelection from './Dialog/DialogDraftPortalSelection'
import {
  clearPortalSelectionBeforeDraft,
  getDraftPortalDialogPostCount,
  shouldShowDraftPortalDialog
} from '@/helpers/posts/draftPortalSelection'
import { getContactsAnnoncesEnTete } from '@/services/contacts'
import { syncStoreWithRoute, getAnnonceParenteFromRoute, isInLotsContext, getEditUrl } from '@/helpers/programContext'
import { convertApiFiltersToStore } from '@/utils/filterConverter'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'

export default {
  name: 'PostsListImmo',
  components: {
    UbiPageContainer,
    ButtonsHeaderList,
    CardsListImmo,
    DialogsPostsListImmo,
    TableListImmo,
    ApiSearchForm,
    DialogChangeUserMultiplePosts,
    DialogDraftPortalSelection
  },
  data () {
    return {
      affichageReduit: false,
      allPostSelected: [],
      annonceFlux: false,
      //  État d'initialisation du composant de recherche
      searchInitialized: false,
      //  Flag pour indiquer que les données sont prêtes
      dataReady: false,
      annoncesContacts: {},
      bienVenduModaleArchiveNOk: false,
      bienVenduModaleArchiveOk: false,
      bienVenduToArchive: null,
      bienVendus: true,
      changedState: '',
      contacts: [],
      deleteId: null,
      labelModeleTerrain: '',
      limits: [5, 10, 20, 50],
      listeModeles: null,
      listeProgramModeles: null,
      listeTerrains: null,
      loadingCMIcreatePost: false,
      modalConfirmedChangeContactList: false,
      showAssignUserModal: false,
      assignUserSelection: [],
      showDraftPortalDialog: false,
      draftPortalDialogPostCount: 1,
      pendingDraftAction: null,
      modalCreateLotFromProgramDisabled: true,
      modalShowModels: false,
      referenceDuplication: null,
      rulesCMI: {
        selectTypeObjetModele: [
          {
            required: true,
            message: this.$t('validator.selectTypeObjetModeleRequired'),
            trigger: 'blur'
          }
        ],
        currentModelId: [
          {
            required: true,
            message: this.$t('validator.currentModelIdRequired'),
            trigger: 'blur'
          }
        ],
        currentProgramId: [
          {
            required: true,
            message: this.$t('validator.currentProgramIdRequired'),
            trigger: 'blur'
          }
        ],
        currentLandId: [
          {
            required: true,
            message: this.$t('validator.currentProgramIdRequired'),
            trigger: 'blur'
          }
        ]
      },
      rulesPromoter: {
        selectTypeObjetModele: [
          {
            required: true,
            message: this.$t('validator.selectTypeObjetModeleRequired'),
            trigger: 'blur'
          }
        ],
        annonceParente: [
          {
            required: true,
            message: this.$t('validator.annonceParenteRequired'),
            trigger: 'blur'
          }
        ]
      },
      saisieEnLigne: false,
      selectModeleCmiste: false,
      selectTerrainCmisteModele: false,
      selected: [],
      selection: [],
      sortProperties: {
        '-DC': this.$t('general.sort.decreaseDate'),
        DC: this.$t('general.sort.increaseDate'),
        R: this.$t('general.sort.reference'),
        T: this.$t('general.sort.title')
      },
      titreModalConfirmedDeleteList: '',
      unselect: false,
      users: [],
      isDeferredMode: false
    }
  },
  computed: {
    ...mapState('postsListImmo', [
      'filter',
      'results',
      'loadingStatus',
      'modalConfirmedDeleteList',
      'modalCreationLot',
      'modalCmisteModelDisabled',
      'modalDuplicate',
      'currentId',
      'currentModelId',
      'currentLandId',
      'currentProgramId',
      'programsModalPromoter'
    ]),
    ...mapState('dialogsPostsListImmo', [
      'selectTypeObjetModele'
    ]),
    ...mapGetters([
      'hasMultiAccounts',
      'isMainAccount',
      'isSubAdmin',
      'isSubUser',
      'getOfferTypes',
      'getPickerOptionsShortcuts',
      'getSitimmoUser',
      'isCmiste'
    ]),
    ...mapGetters('postsListImmo', [
      'getList',
      'annonceParente',
      'fetchModeles',
      'getPage',
      'getLimit',
      'getSort'
    ]),

    currentId: {
      get () {
        return this.$store.getters['postsListImmo/currentId']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_CURRENT_ID', value)
      }
    },
    selectTypeObjetModele: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/selectTypeObjetModele']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_SELECT_TYPE_OBJET_MODELE', value)
      }
    },
    modalDelete: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/modalDelete']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_MODAL_DELETE', value)
      }
    },
    modalDuplicate: {
      get () {
        return this.$store.getters['postsListImmo/modalDuplicate']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_MODAL_DUPLICATE', value)
      }
    },
    modalConfirmedDeleteList: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/modalConfirmedDeleteList']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_MODAL_CONFIRMED_DELETE_LIST', value)
      }
    },
    currentModelId: {
      get () {
        return this.$store.getters['postsListImmo/currentModelId']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_CURRENT_MODEL_ID', value)
      }
    },
    modalCmisteModelDisabled: {
      get () {
        return this.$store.getters['postsListImmo/modalCmisteModelDisabled']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_MODAL_CMISTE_MODEL_DISABLED', value)
      }
    },
    limit: {
      get () {
        return this.getLimit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
      }
    },
    nbStocks () {
      return this.getSitimmoUser.stocks.length
    },
    packExpert () {
      return this.getSitimmoUser.packDiffusion === 'pack_expert'
    },
    page: {
      get () {
        return this.getPage
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
      }
    },
    pageTitle () {
      if (this.isPromoteur) {
        if (isInLotsContext(this.$route)) {
          return this.$t('posts.list.pageTitleLots')
        } else {
          return this.$t('posts.list.pageTitlePrograms')
        }
      }
      return this.$t('posts.list.pageTitleAds')
    },
    parentPageTitle () {
      if (this.isPromoteur) {
        if (isInLotsContext(this.$route)) {
          return 'Lots'
        } else {
          return 'Programmes'
        }
      }
      return 'Annonces'
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    possedeContactManager () {
      return this.$store.getters.possedeContactManager
    },
    refreshProgramme () {
      return this.$store.getters['posts/getRefreshProgramme']
    },
    saisit_en_ligne () {
      return (
        getFromSnake(this.getSitimmoUser, 'saisit_annonces_en_ligne') === true ||
        getFromSnake(this.getSitimmoUser, 'saisit_en_ligne_et_flux') === true
      )
    },
    sort: {
      get () {
        return this.getSort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
      }
    },
    stocks () {
      return this.getSitimmoUser.stocks
    },
    user () {
      return this.$store.getters.getUser
    },
    userJob () {
      return this.getSitimmoUser.metier
    },
    isPromoteur () {
      return this.getSitimmoUser.metier === 'PROMOTEUR'
    },
    isBailleurSocial () {
      return this.getSitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isCmiste () {
      return this.getSitimmoUser.metier === 'CMI'
    },

    // === NOUVEAU SYSTÈME API ===
    currentRoute () {
      // Déterminer la route pour l'API selon le contexte
      if (this.annonceParente) {
        return 'posts/lots'
      }

      //  Gérer la bibliothèque de contenus
      if (this.$route.name === 'content-library') {
        return 'content-library'
      }

      return 'posts/immo/list'
    },

    userContext () {
      // Contexte utilisateur simplifié pour l'API
      return {
        metier: this.getSitimmoUser.metier || 'AGENCE',
        advertiser: this.getSitimmoUser.advertiser || this.getSitimmoUser.annonceur,
        annonceParente: this.annonceParente || false
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 47)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  async beforeMount () {
    // Synchroniser le store avec l'URL au démarrage
    // Si on est sur la route 'posts-lots', utiliser le paramètre programId
    if (this.$route.name === 'posts-lots' && this.$route.params.programId) {
      this.SET_ANNONCE_PARENTE(this.$route.params.programId)
      // Réinitialiser les filtres et appliquer le preset par défaut pour les lots
      this.resetFilter()
      this.SET_ANNONCE_PARENTE(this.$route.params.programId) // Remettre après reset
      // Appliquer le preset "lotsDefault" (A,B par défaut pour les lots)
      this.SET_PRESET('lotsDefault')
    } else {
      syncStoreWithRoute(this.$route, this.$store)
    }

    this.SET_MODAL_SHOW_PROGRAMS_PROMOTER(false)
    this.affichageReduit = this.getAffichageReduitComponent()
    if (this.$route.params.resetParent) {
      this.filter.annonceParente = null
    }

    if (this.fetchModeles) {
      this.SET_ANNONCES_MODELES(true)
      this.SET_PRESET('modeles')
    }

    // Synchroniser annoncesModeles avec le preset 'modeles' chargé depuis les filtres sauvegardés.
    // Sans cela, un sub-user qui revient sur la liste avec un preset='modeles' persisté
    // n'aurait pas annoncesModeles=true et le filtre USER_DATA exclurait tous les modèles
    // non explicitement attribués (modèles du compte principal).
    if (this.$store.state.postsListImmo.filter.preset === 'modeles'
        && !this.$store.state.postsListImmo.filter.annoncesModeles) {
      this.SET_ANNONCES_MODELES(true)
    }

    if (this.$route.name === 'content-library') {
      this.filters = null
      this.filter.page = 1
      // Marquer qu'on est sur la bibliothèque de contenus (partagée)
      // pour ne pas filtrer par USER_DATA_CODE/VALUE
      this.addFilter({ isContentLibrary: true })
    } else {
      // Purger isContentLibrary + annoncesModeles collants après un passage
      // par la bibliothèque (store Vuex partagé entre routes remountées).
      // Ne pas toucher annoncesModeles si fetchModeles (création depuis modèle).
      const filters = { isContentLibrary: false }
      if (!this.fetchModeles) {
        filters.annoncesModeles = null
      }
      this.addFilter(filters)
    }

    if (this.$route.name !== 'content-library') {
      this.$route.meta.title = this.pageTitle
    }

    this.SET_MODAL_SHOW_MODELS_CMISTE(false)
    if (this.$route.matched[1]) {
      this.$route.matched[1].meta.title = this.parentPageTitle
    }

    if (this.$store.getters.saisit_en_ligne === false && this.filters && Array.isArray(this.filters)) {
      this.filters.pop()
    }

    // this.fetchList(); //this is done inside searchfilter
    //  CRITIQUE : Charger les données AVANT de monter ApiSearchForm
    // pour que les règles de visibilité soient correctement évaluées
    if (this.hasMultiAccounts) {
      this.users = (
        await getUsers({
          active: true,
          pagination: false,
          roles: '!ROLE_CONTACT'
        })
      ).list
    }

    //  Charger les contacts pour les règles de visibilité
    const contactsData = await getUsers({ active: true, pagination: false })
    if (contactsData) {
      this.contacts = contactsData.list
    } else {
      console.warn(' PostsListImmo - Aucun contact chargé')
    }

    //  Indiquer que les données sont prêtes AVANT de monter ApiSearchForm
    this.dataReady = true

    //  Laisser ApiSearchForm gérer le chargement initial
    // if (this.$route.name === 'content-library') {
    //   await this.fetchList()
    // }

    if (this.possedeContactManager) {
      const callContacts = await getContactsAnnoncesEnTete({
        beforeContacts: null,
        afterContacts: null
      })
      if (callContacts.infos && callContacts.infos.infosAnnonces) {
        this.annoncesContacts = callContacts.infos.infosAnnonces
        this.SET_CONTACTS_ANNONCES(this.annoncesContacts)
      }
    }
    this.SET_FETCH_MODELES(false)
    // await this.fetchList()
  },
  watch: {
    // Surveiller les changements de route pour synchroniser le store
    '$route' (to, from) {
      // Gérer le flag isContentLibrary lors des changements de route
      if (to.name === 'content-library') {
        this.addFilter({ isContentLibrary: true })
      } else if (from.name === 'content-library') {
        // Purger isContentLibrary + annoncesModeles collants (store partagé).
        // Ne pas toucher annoncesModeles si fetchModeles (création depuis modèle).
        const filters = { isContentLibrary: false }
        if (!this.fetchModeles) {
          filters.annoncesModeles = null
        }
        this.addFilter(filters)
      }

      if (to.name !== from.name) {
        if (to.name === 'posts-lots' && to.params.programId) {
          this.SET_ANNONCE_PARENTE(to.params.programId)
          //  Laisser ApiSearchForm gérer le chargement
          // this.fetchList()
        } else if (to.name === 'posts' && from.name === 'posts-lots') {
          this.SET_ANNONCE_PARENTE(null)
          // Appliquer le preset par défaut de façon transparente
          this.resetFilter()
          this.SET_PRESET('allAds')
          //  SIMPLIFIÉ : Laisser ApiSearchForm gérer les presets via les templates backend
          // Le fetchList() sera déclenché par ApiSearchForm via handleConfigLoaded
        } else {
          syncStoreWithRoute(to, this.$store)
          //  SIMPLIFIÉ : Laisser ApiSearchForm gérer complètement les presets via les templates backend
          // Le fetchList() sera déclenché par ApiSearchForm via handleConfigLoaded
        }
      } else if (to.name === 'posts-lots' && to.params.programId !== from.params.programId) {
        this.SET_ANNONCE_PARENTE(to.params.programId)
        //  Laisser ApiSearchForm gérer le chargement
        // this.fetchList()
      } else if (to.name === 'posts' && to.query.annonceParente !== from.query.annonceParente) {
        syncStoreWithRoute(to, this.$store)
        //  Laisser ApiSearchForm gérer complètement les appels
        // Le fetchList() sera déclenché par ApiSearchForm via handleConfigLoaded
      }
    },
    userFilter: function (user) {
      // Ne pas déclencher si nous sommes en mode différé
      if (this.isDeferredMode) {
        return
      }

      // Ne pas appliquer le filtre utilisateur en mode modèles :
      // un sub-user doit voir ses modèles ET ceux du compte principal (non attribués).
      if (this.filter.preset === 'modeles' || this.filter.annoncesModeles === true) {
        return
      }

      if (user) {
        const userMatch = this.users.find(x => x.id === this.filter.user)

        if (userMatch.identifierCode && userMatch.identifierValue) {
          this.addFilter({
            dataValues: {
              USER_DATA_CODE: userMatch.identifierCode,
              USER_DATA_VALUE: userMatch.identifierValue
            }
          })
        } else {
          this.addFilter({
            dataValues: { USER_DATA_CODE: null, USER_DATA_VALUE: null }
          })
        }
      } else {
        this.addFilter({
          dataValues: { USER_DATA_CODE: null, USER_DATA_VALUE: null }
        })
      }
    },
    refreshProgramme: function (val) {
      this.SET_ANNONCE_PARENTE(null)
    }
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'SET_LIST',
      'setResults',
      'resetFilter',
      'setObjectType',
      'SET_LOADING_STATUS',
      'SET_LOADING_CMI_CREATE_POST',
      'SET_ANNONCE_PARENTE',
      'SET_CURRENT_LAND_ID',
      'SET_CURRENT_MODEL_ID',
      'SET_CURRENT_ID',
      'SET_CURRENT_PROGRAM_ID',
      'SET_CONTACTS_ANNONCES',
      'SET_ANNONCES_MODELES',
      'SET_PROGRAMS_MODAL_PROMOTER',
      'SET_MODAL_SHOW_MODELS',
      'SET_FETCH_MODELES',
      'SET_PRESET'
    ]),
    ...mapMutations('dialogsPostsListImmo', [
      'SET_MODAL_SHOW_MODELS_CMISTE',
      'SET_MODAL_CONFIRMED_DELETE_LIST',
      'SET_BIEN_VENDU_MODALE_ARCHIVE_OK',
      'SET_POST_TO_DELETE',
      'SET_POST_STATE_TO_DELETE',
      'SET_MODAL_SHOW_PROGRAMS_PROMOTER',
      'SET_MODAL_DUPLICATE',
      'SET_MODAL_USE_MODEL',
      'SET_MODAL_DELETE'
    ]),
    ...mapActions('postsListImmo', ['loadPosts']),
    ...mapActions('dialogsPostsListImmo', ['patchPost']),
    // === NOUVELLES MÉTHODES API ===
    async handleSearchFromApi (filters) {
      //  CONVERSION : Utiliser l'utilitaire de conversion
      const convertedFilters = convertApiFiltersToStore(filters, {
        metier: this.getSitimmoUser.metier
      })

      convertedFilters.search = (filters.search || '').trim()

      this.$store.commit('postsListImmo/addFilter', convertedFilters)

      // Réinitialiser la page à 1 lors d'un changement de filtre
      this.$store.commit('postsListImmo/setPage', 1)
      this.$store.commit('postsListImmo/setOffset', 0)

      try {
        //  Toujours sans loader (chargement rapide)
        await this.$store.dispatch('postsListImmo/loadPosts', {
          filters: null, // Utilise les filtres du store
          force: true, // Force l'exécution même si loadingStatus = true
          silent: true // Ne jamais afficher le loader après le chargement initial
        })
      } catch (error) {
        console.error(' [handleSearchFromApi] Erreur lors de la recherche:', error)
        //  Désactiver le loader en cas d'erreur
        this.SET_LOADING_STATUS(false)
      }
    },

    handleConfigLoaded (config) {
      this.searchInitialized = true
      //  Ne plus déclencher ici, attendre @ready
    },

    handleSearchFormReady () {
      //  Déclencher la recherche quand ApiSearchForm est complètement prêt
      this.$nextTick(() => {
        if (this.$refs.apiSearchForm) {
          this.$refs.apiSearchForm.emitSearch()
        } else {
          console.error(' [handleSearchFormReady] $refs.apiSearchForm non trouvé')
        }
      })
    },

    //  Gestion unifiée des loaders
    handleLoadingStart (message = 'Chargement...') {
      this.SET_LOADING_STATUS(true)
    },

    handleLoadingEnd () {
      //  Seulement désactiver en cas d'erreur (émis seulement dans le catch)
      this.SET_LOADING_STATUS(false)
    },

    handleConfigError (error) {
      console.error(' Erreur de configuration API:', error)
      this.$message.error('Erreur lors du chargement de la configuration de recherche')
      //  Désactiver le loader en cas d'erreur
      this.SET_LOADING_STATUS(false)
    },
    scrollWin () {
      window.scrollTo(500, 0)
    },
    daysRemaining (dateBegin, nbDays) {
      const dateEnd = moment(dateBegin, 'DD/MM/YYYY HH:mm:ss')
        .add(nbDays, 'd')
        .format('DD/MM/YYYY HH:mm:ss')
      const now = moment()
      const remaining = moment(now, 'DD/MM/YYYY HH:mm:ss').diff(
        moment(dateEnd, 'DD/MM/YYYY HH:mm:ss')
      )
      const formattedRemaining = Math.round(
        Math.abs(moment.duration(remaining).asDays())
      )
      return formattedRemaining
    },
    async closePopupBiensVendus () {
      this.SET_LOADING_STATUS(true)
      const result = await putStopPopupBiensVendus(this.user)
      if (result.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
      this.SET_LOADING_STATUS(false)
    },
    async fetchList () {
      //  NOUVEAU SYSTÈME : Plus besoin de logique complexe, ApiSearchForm gère tout
      if (!this.searchInitialized) {
        return
      }

      // Seules les logiques spéciales qui ne sont pas dans les filtres de recherche
      this.handleSpecialFilters()

      await this.$store.dispatch('postsListImmo/loadPosts')

      this.updateSourceFlags()
      this.scrollWin()
    },
    handleSpecialFilters () {
      // Biens vendus depuis URL (logique de navigation)
      if (this.$route.params.getBV) {
        this.filter.annoncesVendues = true
      }

      //  SIMPLIFIÉ : La logique CMI est maintenant gérée dans le watcher $route
      // Plus besoin de logique complexe ici
    },

    updateSourceFlags () {
      const hasSaisieImmo = this.results && this.results.list
        ? this.results.list.some(element => element.sourceCode === 'SAISIE_IMMO')
        : false

      const hasFlux = this.results && this.results.list
        ? this.results.list.some(element => element.sourceCode !== 'SAISIE_IMMO')
        : false

      this.saisieEnLigne = hasSaisieImmo
      this.annonceFlux = hasFlux
    },
    async archiverBienVenduModale (state) {
      if (state.published === false) {
        this.bienVenduToArchive = state.id
        // this.bienVenduModaleArchiveOk = true
        this.SET_BIEN_VENDU_MODALE_ARCHIVE_OK = true
      } else {
        this.bienVenduModaleArchiveNOk = true
      }
    },
    async archiverBienVendu () {
      await this.supprimer(this.bienVenduToArchive)
    },
    async exporter (state) {
      let selection = []
      if (state && state.selection) {
        selection = state.selection
      }
      await this.$store.dispatch('postsListImmo/exportPosts', selection)
    },
    formatSelectedIds (selection) {
      if (!selection) return null
      this.selection = selection
      return selection.join(',')
    },
    async fetchTerrains () {
      const terrainsFilters = {
        itemsPerPage: 150
      }
      const result = await getPosts(terrainsFilters)
      if (result.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.SET_LOADING_STATUS(false)
        return false
      }
    },
    async getModels () {
      const result = await getPosts(this.filter)
      if (result.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.SET_LOADING_STATUS(false)
        return false
      }
    },
    async doSelect (type) {
      if (type === '*') {
        this.selected = []
        if (this.results && this.results.list !== undefined) {
          const tmpSelection = this.results.list.map(({ id }) => id)
          this.selected = this.selected.concat(tmpSelection)
        }
      }
      if (type === null) {
        if (this.results && this.results.list !== undefined) {
          this.unselect = true
          this.results.list.map(({ id }) => id)
          this.selected = []
          this.unselect = false
        }
      }
    },
    async setReferenceDuplication (payload) {
      this.$store.commit('dialogsPostsListImmo/SET_LOADING_STATUS', true)
      this.referenceDuplication = payload.reference
      let redirect = false
      if (payload.redirect) {
        redirect = true
      }
      const newPayload = {
        id: this.currentId,
        reference: payload.reference,
        redirect: redirect,
        skipSuccessMessage: redirect // Skip message si redirection pour obtenir la réponse directe
      }
      try {
        await this.dupliquer(newPayload)
        this.$store.commit('dialogsPostsListImmo/SET_MODAL_USE_MODEL', false)
      } finally {
        this.$store.commit('dialogsPostsListImmo/SET_LOADING_STATUS', false)
      }
    },
    closeModalDuplicate () {
      this.modalDuplicate = false
    },
    closeModalDelete () {
      this.$store.commit('dialogsPostsListImmo/SET_MODAL_DELETE', false)
    },
    closeModalDeleteSelected () {
      this.$store.commit('postsListImmo/setModalConfirmedDeleteList', false)
    },
    async dupliquer (state) {
      const response = await this.$store.dispatch('dialogsPostsListImmo/duplicatePost', {
        id: state.id,
        reference: state.reference,
        draft: true,
        skipSuccessMessage: state.skipSuccessMessage || false
      })

      // Vérifier si la duplication a réussi : réponse avec un id et pas d'erreur
      if (response) {
        if (response.id && response.type !== 'error') {
          if (state.redirect) {
            // FIX: Récupérer l'annonce parente du contexte actuel pour construire l'URL correcte
            const currentAnnonceParente = getAnnonceParenteFromRoute(this.$route)
            const editUrl = getEditUrl(response.id, currentAnnonceParente, 'SAISIE_IMMO')
            this.$router.push(editUrl)
          } else {
            // FIX: Sauvegarder les filtres (incluant le tri) AVANT de recharger la liste
            if (this.$refs.apiSearchForm && typeof this.$refs.apiSearchForm.saveFilters === 'function') {
              await this.$refs.apiSearchForm.saveFilters()
            }
            await this.fetchList()
          }
        } else if (response.type === 'success') {
          // Cas où handlePostAction retourne une structure avec type: 'success'
          if (state.redirect) {
            // FIX: Récupérer l'annonce parente du contexte actuel pour construire l'URL correcte
            const currentAnnonceParente = getAnnonceParenteFromRoute(this.$route)
            const editUrl = getEditUrl(response.data.id, currentAnnonceParente, 'SAISIE_IMMO')
            this.$router.push(editUrl)
          } else {
            if (this.$refs.apiSearchForm && typeof this.$refs.apiSearchForm.saveFilters === 'function') {
              await this.$refs.apiSearchForm.saveFilters()
            }
            await this.fetchList()
          }
        } else if (response.type === 'error') {
          this.$message({ message: response.message, type: 'error' })
        }
      }
    },
    async fusionner (state) {
      const response = await this.$store.dispatch('dialogsPostsListImmo/fusionnerPost', {
        ...state,
        selectTypeObjetModele: this.$store.getters['dialogsPostsListImmo/selectTypeObjetModele']
      })

      // Vérifier si la fusion a réussi : réponse avec un id et pas d'erreur
      if (response && response.id && response.type !== 'error' && this.isCmiste) {
        if (state.redirect) {
          // FIX: Récupérer l'annonce parente du contexte actuel pour construire l'URL correcte
          const currentAnnonceParente = getAnnonceParenteFromRoute(this.$route)
          const editUrl = getEditUrl(response.id, currentAnnonceParente, 'SAISIE_IMMO')
          this.$router.push(editUrl)
        } else {
          if (this.$refs.apiSearchForm && typeof this.$refs.apiSearchForm.saveFilters === 'function') {
            await this.$refs.apiSearchForm.saveFilters()
          }
          await this.fetchList()
        }
      } else if (response && response.type === 'success' && this.isCmiste) {
        // Cas où handlePostAction retourne une structure avec type: 'success'
        if (state.redirect) {
          // FIX: Récupérer l'annonce parente du contexte actuel pour construire l'URL correcte
          const currentAnnonceParente = getAnnonceParenteFromRoute(this.$route)
          const editUrl = getEditUrl(response.data.id, currentAnnonceParente, 'SAISIE_IMMO')
          this.$router.push(editUrl)
        } else {
          if (this.$refs.apiSearchForm && typeof this.$refs.apiSearchForm.saveFilters === 'function') {
            await this.$refs.apiSearchForm.saveFilters()
          }
          await this.fetchList()
        }
      }
    },
    openDuplicateModal (state) {
      this.currentId = state.id
      this.SET_MODAL_DUPLICATE(true)
    },
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.getSitimmoUser.id)
    },
    openUseModelModal (state) {
      this.eventAnalytics('utiliser_modele')
      this.SET_CURRENT_ID(state.id)
      this.SET_MODAL_USE_MODEL(true)
    },
    async supprimer (id) {
      this.unselect = true
      this.SET_LOADING_STATUS(true)

      if (this.$store.getters['dialogsPostsListImmo/postToDelete']) {
        id = this.$store.getters['dialogsPostsListImmo/postToDelete']
      }
      try {
        await this.$store.dispatch('dialogsPostsListImmo/deletePost', id)
      } finally {
        this.SET_LOADING_STATUS(false)
        this.SET_POST_TO_DELETE(null)
        if (this.$refs.apiSearchForm && typeof this.$refs.apiSearchForm.saveFilters === 'function') {
          await this.$refs.apiSearchForm.saveFilters()
        }
        await this.fetchList()
        this.selected = []
        this.unselect = false
      }
    },
    async vendu (id) {
      this.SET_MODAL_DELETE(false)
      this.$router.push({
        name: 'edit-bien-vendu',
        params: {
          id: this.$store.getters['dialogsPostsListImmo/postToDelete']
        }
      })
    },
    async supprimerAll (annonces) {
      this.unselect = true
      this.SET_LOADING_STATUS(true)

      try {
        await this.$store.dispatch('dialogsPostsListImmo/deleteAllPosts', annonces)
      } finally {
        this.SET_LOADING_STATUS(false)
        this.SET_POST_TO_DELETE(null)
        if (this.$refs.apiSearchForm && typeof this.$refs.apiSearchForm.saveFilters === 'function') {
          await this.$refs.apiSearchForm.saveFilters()
        }
        await this.fetchList()
        this.selected = []
        this.unselect = false
      }
    },
    openDeleteModal (state) {
      this.eventAnalytics('supprimer_annonce')
      this.deleteId = state.id
      this.SET_POST_TO_DELETE(state.id)
      this.SET_POST_STATE_TO_DELETE(state.etat)
      this.SET_MODAL_DELETE(true)
    },
    async fetchModels () {
      this.eventAnalytics('a_partir_de_modele')
      this.resetFilter()
      this.setFilter({ annoncesModeles: true })
      this.fetchList()
      this.modalShowModels = true
    },
    async fetchModelsCmiste () {
      this.eventAnalytics('a_partir_de_modele')
      this.resetFilter()
      this.$store.commit('dialogsPostsListImmo/SET_SELECT_TYPE_OBJET_MODELE', null)
      this.$refs.dialogsComponent.resetModalDisplayState()
      this.fetchTerrains()
      this.getModels()
      this.SET_MODAL_SHOW_MODELS_CMISTE(true)
    },
    async fetchModelsLots () {
      this.eventAnalytics('creer_lot_prom_depuis_modele')
      this.SET_MODAL_SHOW_MODELS(true)
      const annonceParente = this.filter.annonceParente
      this.resetFilter()
      this.setFilter({ annoncesModeles: true })
      this.SET_ANNONCE_PARENTE(annonceParente)
      this.filter.annonceParente = annonceParente
      this.fetchList()
    },
    changeContacts (state) {
      this.selection = state.selection
      this.getSitimmoUser.selectionItem = state.selection
      this.$store.commit('postsVo/setModalConfirmedChangeContactList', true)
    },
    changeUsers (event) {
      this.assignUserSelection = (event && event.selection) ? event.selection : []
      this.showAssignUserModal = true
    },
    onAssignUserSuccess () {
      this.showAssignUserModal = false
      this.assignUserSelection = []
      this.doSelect(null)
    },
    closeChangeContacts () {
      this.$store.commit('postsVo/setModalConfirmedChangeContactList', false)
    },
    async onSwitchPublished (id) {
      const selectedIds = [...this.selected]
      const postsList = (this.results && this.results.list) ? this.results.list : []

      if (shouldShowDraftPortalDialog(id, selectedIds, postsList)) {
        this.pendingDraftAction = { id, selectedIds }
        this.draftPortalDialogPostCount = getDraftPortalDialogPostCount(id, selectedIds, postsList)
        this.showDraftPortalDialog = true
        return
      }

      await this.performSwitchPublished(id, selectedIds, true)
    },
    async onDraftPortalKeep () {
      await this.runDraftPortalAction(true)
    },
    async onDraftPortalClear () {
      await this.runDraftPortalAction(false)
    },
    onDraftPortalCancel () {
      this.pendingDraftAction = null
    },
    async runDraftPortalAction (keepPortalSelection) {
      const pendingDraftAction = this.pendingDraftAction
      this.pendingDraftAction = null
      if (!pendingDraftAction) {
        return
      }
      this.showDraftPortalDialog = false
      this.SET_LOADING_STATUS(true)
      await this.$nextTick()
      await this.performSwitchPublished(
        pendingDraftAction.id,
        pendingDraftAction.selectedIds,
        keepPortalSelection
      )
    },
    async performSwitchPublished (id, selectedIds, keepPortalSelection) {
      if (!this.loadingStatus) {
        this.SET_LOADING_STATUS(true)
      }
      this.unselect = true
      const postsList = (this.results && this.results.list) ? this.results.list : []

      if (!keepPortalSelection) {
        const clearResult = await clearPortalSelectionBeforeDraft({
          id,
          selectedIds,
          postsList,
          sitimmoUser: this.$store.getters.getSitimmoUser
        })

        if (clearResult && clearResult.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
          this.SET_LOADING_STATUS(false)
          this.unselect = false
          return
        }
      }

      const result = await this.$store.dispatch('postsListImmo/switchPublishedState', {
        id,
        selectedIds,
        isAffichageReduit: this.affichageReduit
      })

      if (result && result.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }

      this.unselect = false
    },
    upperCase (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    },
    // Méthode supprimée - la navigation se fait maintenant directement par le router

    // Nouvelle méthode extraite
    updateRouteMeta () {
      if (this.$route && this.$route.meta) {
        this.$route.meta.title = this.pageTitle
        if (this.$route.matched && this.$route.matched[1]) {
          this.$route.matched[1].meta.title = this.parentPageTitle
        }
      }
    },
    async handleCommandPromoter (command) {
      if (command.name === 'fetchModels') {
        this.fetchModels()
      }
      if (command.name === 'fetchModelsLots') {
        this.fetchModelsLots()
      }
      if (command.name === 'newProgram') {
        this.$router.push({
          name: 'post-new',
          query: { type: 'program' }
        })
      }
      if (command.name === 'newLot') {
        this.SET_MODAL_SHOW_PROGRAMS_PROMOTER(true)
        const filterPrograms = {
          annonceParente: null,
          page: 1,
          typeObjets: 3000,
          perPage: 250
        }
        const result = await this.$store.dispatch('postsListImmo/loadPosts', filterPrograms)

        this.SET_LOADING_STATUS(false)
        this.SET_PROGRAMS_MODAL_PROMOTER(result.list)
      }
    },
    async gestionModalNewLot () {
      this.SET_LOADING_STATUS(true)
      const filterPrograms = {
        annonceParente: null,
        page: 1,
        typeObjets: 3000,
        perPage: 250
      }
      const result = await getPosts(filterPrograms)
      this.SET_PROGRAMS_MODAL_PROMOTER(result.list)
      this.SET_LOADING_STATUS(false)
      this.SET_MODAL_SHOW_PROGRAMS_PROMOTER(true)
    },
    handleCommand (command) {
      if (command.name === 'delete') {
        this.openDeleteModal(command.id)
      } else if (command.name === 'useModel') {
        this.openUseModelModal(command.id)
      } else if (command.name === 'duplicate') {
        this.openDuplicateModal(command.id)
      } else if (command.name === 'edit') {
        // Plus besoin de nettoyer creationProgramme - déterminé par l'URL
        this.$router.push({
          name: 'post-edit',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      } else if (command.name === 'attendanceReport') {
        this.eventAnalytics('rapport_presence')
        this.$router.push({
          name: 'attendance-report-post',
          params: { post: command.id }
        })
      } else if (command.name === 'diffuseLater') {
        this.eventAnalytics('programmer_diffusion')
        this.$emit('diffuse-later', {
          id: command.id,
          diffuseLaterDate: command.diffuseLaterDate
        })
      } else if (command.name === 'private-note') {
        this.eventAnalytics('acces_note_privee')
        this.$router.push({
          name: 'private-note',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      }
    },
    gestionAffichageReduit (rep) {
      this.affichageReduit = rep
      this.$store.commit('donnees/SET_AFFICHAGE_REDUIT', this.affichageReduit)
    },
    getAffichageReduitComponent () {
      return this.$store.getters['donnees/getAffichageReduit']
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
      } else {
        // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })

      const index = this.selected.indexOf(row.id)

      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    activationModalConfirmedDeleteList (state) {
      this.selection = state.selection
      if (state.quantite == 1) {
        this.titreModalConfirmedDeleteList =
            'Etes-vous sûr de vouloir supprimer votre annonce ?'
      } else {
        this.titreModalConfirmedDeleteList =
            'Etes-vous sûr de vouloir supprimer vos ' +
            state.quantite +
            ' annonces ?'
      }
      this.SET_MODAL_CONFIRMED_DELETE_LIST(true)
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";
.el-loading-spinner {
  top: 10% !important;
}
.lienContactsListeAnnonces {
  text-decoration: none;
  color: #1a4a56;
}

.lienContactsListeAnnonces.hover {
  text-decoration: underline;
  text-decoration-color: #1a4a56;
  color: #1a4a56;
}

.PostsList {
  &-selection {
    @extend .mb-5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  /*.no-photo {
    //padding-left: 20%;
    //padding-right: 20%;
    //padding-top: 15%;
    //padding-bottom: 15%;
    //margin-left: 20%;
    //margin-right: 20%;
    //margin-top: 50px;
    //margin-bottom: 50px;
  }*/

  .PostItem {
    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &-reference {
      @extend .font-secondary;
      text-transform: uppercase;
    }

    &-location,
    &-price,
    &-date {
      font-size: $font-size-lg;
    }

    &-price {
      float: left;
    }

    &-date {
      float: right;
    }

    &-date-program {
      float: right;
      position: relative;
      bottom: 19px;
    }

    &-actions {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &-contacts {
      @extend .font-secondary;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &-contacts-value {
      font-size: $font-size-lg-alt;
      line-height: $font-size-lg-alt;
      font-weight: $font-weight-bold;
    }
    &-contacts-label {
      text-transform: uppercase;
      font-size: $font-size-sm-alt;
    }
  }

  @include media-breakpoint-down(md) {
    &-selection {
      flex-direction: column;
      align-items: flex-start;
    }
    &-export {
      align-self: flex-end;
    }
  }

  @include media-breakpoint-down(sm) {
    &-item {
      margin-bottom: map-get($spacers, 3) !important;
    }

    .PostItem {
      &-actions {
        flex-direction: column;

        .PostItem-buttons {
          margin-bottom: map-get($spacers, 3);
        }
      }

      &-contacts {
        align-self: flex-end;
      }
    }
  }
}

.PostsListImmo {
  /*  Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  /* Sélecteur ultra-spécifique pour cette page uniquement */
  &.PostsListImmo ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /* Sélecteur encore plus spécifique avec le conteneur ubi-page-container */
  .ubi-page-container.PostsListImmo ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /*  Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }
}
</style>
